import { ReactComponent as Magalu } from 'core/assets/images/magalu.svg'
import { ReactComponent as Netshoes } from 'core/assets/images/netshoes.svg'
import StyledStockCard from './style'

type TStockChannel = {
  name: string
}

function getChannelLogo(channel: string) {
  const defaultSize = { width: '24px', height: '24px' }
  const defaultLogo = <Magalu style={defaultSize} />

  const logos: Record<string, unknown> = {
    Magalu: defaultLogo,
    Netshoes: <Netshoes style={defaultSize} />,
  }
  return logos[channel as keyof typeof logos] || defaultLogo
}

const ChannelName = ({ name }: TStockChannel) => {
  return (
    <StyledStockCard>
      {getChannelLogo(name)} {name}
    </StyledStockCard>
  )
}

export default ChannelName
